import { render, staticRenderFns } from "./modelChecking.vue?vue&type=template&id=0bf231a3&scoped=true&"
import script from "./modelChecking.vue?vue&type=script&lang=js&"
export * from "./modelChecking.vue?vue&type=script&lang=js&"
import style0 from "./modelChecking.vue?vue&type=style&index=0&id=0bf231a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf231a3",
  null
  
)

export default component.exports